module.exports = __webpack_public_path__ + "static/media/bv.b70ab2f2.svg";